export default __webpack_public_path__ + "static/media/Full_Resume_Clotilde_JUMELLE.b92953c4.pdf";